import client from "../../../api/client";

export default async function getMyRoomListings() {
  const response = await client.get("/room-listings/my");
  return response.data;
}